import { FC } from 'react';

const LoginPage: FC = () => {
  return (
    <div>
      <h1>Login</h1>
      (Pending)
    </div>
  );
};

export default LoginPage;
